// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2022-03-23 10:34:49 +0100 (Wed, 23 Mar 2022) $
// Author      : Dirk Rothe
// Worker      : $Author: o.powroznik $
// Revision    : $Rev: 126080 $
// Purpose     : single record properties lists
// =============================================================================
// ---Third-party imports
import React from 'react'
import {List, Table} from 'semantic-ui-react'

// ---Framework imports
import {isString, strip} from 'ldash'
import log from 'uix/logging'
import {Sel, Actions} from 'uix/registries'
import {useSelector, useState, useEffect, usePhysicalNode} from 'uix/hooks'

// ---Local imports
import {useColumnsForNode} from './hooks'
import {getPropSet} from './propcfg'
import {getColumLabel} from './columnTypes'
import S from './styles.scss'

// ---Globals

// ---Exports

export const PropertyTable = ({
  columnList,
  namespaceLabels = false,
  buildLabel = null,
  raw = false,
}) => {
  let i18n = useSelector(Sel.i18n)

  let rows = columnList.map(col => {
    let {colns, i18nKey, rendered, value} = col
    let label = buildLabel ? buildLabel(i18nKey) : i18n.span(i18nKey)
    if (namespaceLabels && colns) {
      let ns = i18n.span(`colns_${colns}`)
      label = (
        <>
          {ns}: {label}
        </>
      )
    }
    return (
      <Table.Row key={col.id}>
        <Table.Cell className={S.cellLabel}>{label}</Table.Cell>
        <Table.Cell className={S.cellContent}>{rendered}</Table.Cell>
        {raw && <Table.Cell>{`${col.id}: ${value}`}</Table.Cell>}
      </Table.Row>
    )
  })

  return (
    <Table definition compact>
      <Table.Body>{rows}</Table.Body>
    </Table>
  )
}

export const NodeDefaultProps = ({node, showEmpty}) => {
  let colids = getPropSet(node.datatypeName, 'default')
  let columnList = useColumnsForNode({colids, nodeData: node, showEmpty})
}

const DEFAULT_FIELDS = ['otid', 'type', 'caption']
export const PropertyList = ({
  header,
  subheader,
  fields = DEFAULT_FIELDS,
  showEmpty = false,
  columnLabel,
}) => {
  if (isString(fields)) {
    fields = fields.split(',').map(e => strip(e))
  }
  let i18n = useSelector(Sel.i18n)
  let node = usePhysicalNode()

  let columnList = useColumnsForNode({fields, nodeData: node, showEmpty})

  let items = columnList.map(col => {
    let {colns, i18nKey, rendered, value} = col
    let label = getColumLabel(col.id, i18n, i18nKey, columnLabel)
    return (
      <List.Item key={col.id}>
        <List.Header>{label}</List.Header>
        {rendered || <>&nbsp;</>}
      </List.Item>
    )
  })
  let list_head = null
  if (header) {
    list_head = (
      <List.Item>
        <List.Content>
          <List.Header>{header}</List.Header>
          {subheader}
        </List.Content>
      </List.Item>
    )
  }
  return (
    <List horizontal relaxed>
      {list_head}
      {items}
    </List>
  )
}
